// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file bff/admin/admin_user.proto (package com.americanexpress.dining.bff.admin.proto, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ResyUser } from "../../resy/user_pb";
import { file_resy_user } from "../../resy/user_pb";
import type { TockPatron } from "../../tock/patron_pb";
import { file_tock_patron } from "../../tock/patron_pb";
import type { GdusUser } from "../../user/gdus_user_pb";
import { file_user_gdus_user } from "../../user/gdus_user_pb";
import type { ActivateUsersRequestSchema, ActivateUsersResponseSchema, AddSuspectedBotRequestSchema, AddSuspectedBotResponseSchema, BulkUserActionStatusSchema, CancelBulkUserActionRequestSchema, CancelBulkUserActionResponseSchema, DeactivateUsersRequestSchema, DeactivateUsersResponseSchema, DeleteUsersRequestSchema, DeleteUsersResponseSchema, GetBulkUserActionStatusRequestSchema, ResolveUsersRequestSchema, ResolveUsersResponseSchema, RetryGdaEligibilityRequestSchema, RetryGdaEligibilityResponseSchema, StartBulkUserActionRequestSchema, StartBulkUserActionResponseSchema, SyncUserRequestSchema, SyncUserResponseSchema, UpdateUserRequestSchema, UpdateUserResponseSchema } from "../../user/user_administration_pb";
import { file_user_user_administration } from "../../user/user_administration_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bff/admin/admin_user.proto.
 */
export const file_bff_admin_admin_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_resy_user, file_tock_patron, file_user_gdus_user, file_user_user_administration]);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUserRequest
 */
export type AdminUserRequest = Message<"com.americanexpress.dining.bff.admin.proto.AdminUserRequest"> & {
  /**
   * @generated from field: optional string search_string = 1;
   */
  searchString?: string;

  /**
   * 0-indexed page number, defaults to 0
   *
   * @generated from field: optional int32 page = 2;
   */
  page?: number;

  /**
   * results per page, defaults to and capped at 25
   *
   * @generated from field: optional int32 page_size = 3;
   */
  pageSize?: number;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUserRequest.
 * Use `create(AdminUserRequestSchema)` to create a new message.
 */
export const AdminUserRequestSchema: GenMessage<AdminUserRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 0);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminReservationSummary
 */
export type AdminReservationSummary = Message<"com.americanexpress.dining.bff.admin.proto.AdminReservationSummary"> & {
  /**
   * @generated from field: optional string venue_name = 1;
   */
  venueName?: string;

  /**
   * ISO-8601 datetime string in venue timezone
   *
   * @generated from field: optional string start_date_time = 2;
   */
  startDateTime?: string;

  /**
   * @generated from field: optional int32 party_size = 3;
   */
  partySize?: number;

  /**
   * e.g. BOOKED, CANCELED, NO_SHOW, LEFT, SEATED (from PartyState)
   *
   * @generated from field: optional string status = 4;
   */
  status?: string;

  /**
   * how the visit originated: BOOKING or WALKIN
   *
   * @generated from field: optional string reservation_type = 5;
   */
  reservationType?: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminReservationSummary.
 * Use `create(AdminReservationSummarySchema)` to create a new message.
 */
export const AdminReservationSummarySchema: GenMessage<AdminReservationSummary> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 1);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup
 */
export type ReservationSourceGroup = Message<"com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminReservationSummary reservations = 1;
   */
  reservations: AdminReservationSummary[];

  /**
   * @generated from field: com.americanexpress.dining.bff.admin.proto.ReservationSourceStatus status = 2;
   */
  status: ReservationSourceStatus;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup.
 * Use `create(ReservationSourceGroupSchema)` to create a new message.
 */
export const ReservationSourceGroupSchema: GenMessage<ReservationSourceGroup> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 2);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUserEvent
 */
export type AdminUserEvent = Message<"com.americanexpress.dining.bff.admin.proto.AdminUserEvent"> & {
  /**
   * @generated from oneof com.americanexpress.dining.bff.admin.proto.AdminUserEvent.event
   */
  event: {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent resy_user_created = 1;
     */
    value: ResyUserCreatedEvent;
    case: "resyUserCreated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent tock_patron_created = 2;
     */
    value: TockPatronCreatedEvent;
    case: "tockPatronCreated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent gdus_user_created = 3;
     */
    value: GdusUserCreatedEvent;
    case: "gdusUserCreated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent gdus_user_deactivated = 4;
     */
    value: GdusUserDeactivatedEvent;
    case: "gdusUserDeactivated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent gdus_user_reactivated = 5;
     */
    value: GdusUserReactivatedEvent;
    case: "gdusUserReactivated";
  } | {
    /**
     * @generated from field: com.americanexpress.dining.bff.admin.proto.GdusUserDeletedEvent gdus_user_deleted = 6;
     */
    value: GdusUserDeletedEvent;
    case: "gdusUserDeleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUserEvent.
 * Use `create(AdminUserEventSchema)` to create a new message.
 */
export const AdminUserEventSchema: GenMessage<AdminUserEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 3);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent
 */
export type ResyUserCreatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: uint64 user_id = 2;
   */
  userId: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.ResyUserCreatedEvent.
 * Use `create(ResyUserCreatedEventSchema)` to create a new message.
 */
export const ResyUserCreatedEventSchema: GenMessage<ResyUserCreatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 4);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent
 */
export type TockPatronCreatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: int64 patron_id = 2;
   */
  patronId: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.TockPatronCreatedEvent.
 * Use `create(TockPatronCreatedEventSchema)` to create a new message.
 */
export const TockPatronCreatedEventSchema: GenMessage<TockPatronCreatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 5);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent
 */
export type GdusUserCreatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: optional string gdus_uuid = 2;
   */
  gdusUuid?: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GdusUserCreatedEvent.
 * Use `create(GdusUserCreatedEventSchema)` to create a new message.
 */
export const GdusUserCreatedEventSchema: GenMessage<GdusUserCreatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 6);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent
 */
export type GdusUserDeactivatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: optional string reason = 2;
   */
  reason?: string;

  /**
   * @generated from field: optional uint64 updated_by_tock_patron_id = 3;
   */
  updatedByTockPatronId?: bigint;

  /**
   * @generated from field: optional string gdus_uuid = 4;
   */
  gdusUuid?: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GdusUserDeactivatedEvent.
 * Use `create(GdusUserDeactivatedEventSchema)` to create a new message.
 */
export const GdusUserDeactivatedEventSchema: GenMessage<GdusUserDeactivatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 7);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent
 */
export type GdusUserReactivatedEvent = Message<"com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: optional string reason = 2;
   */
  reason?: string;

  /**
   * @generated from field: optional uint64 updated_by_tock_patron_id = 3;
   */
  updatedByTockPatronId?: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GdusUserReactivatedEvent.
 * Use `create(GdusUserReactivatedEventSchema)` to create a new message.
 */
export const GdusUserReactivatedEventSchema: GenMessage<GdusUserReactivatedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 8);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GdusUserDeletedEvent
 */
export type GdusUserDeletedEvent = Message<"com.americanexpress.dining.bff.admin.proto.GdusUserDeletedEvent"> & {
  /**
   * @generated from field: string date_time = 1;
   */
  dateTime: string;

  /**
   * @generated from field: optional uint64 deleted_by_tock_patron_id = 2;
   */
  deletedByTockPatronId?: bigint;

  /**
   * @generated from field: optional string gdus_uuid = 3;
   */
  gdusUuid?: string;

  /**
   * @generated from field: optional string source = 4;
   */
  source?: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GdusUserDeletedEvent.
 * Use `create(GdusUserDeletedEventSchema)` to create a new message.
 */
export const GdusUserDeletedEventSchema: GenMessage<GdusUserDeletedEvent> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 9);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUser
 */
export type AdminUser = Message<"com.americanexpress.dining.bff.admin.proto.AdminUser"> & {
  /**
   * @generated from field: optional com.americanexpress.dining.user.proto.GdusUser gdus_user = 1;
   */
  gdusUser?: GdusUser;

  /**
   * @generated from field: optional com.americanexpress.dining.resy.proto.ResyUser resy_user = 2;
   */
  resyUser?: ResyUser;

  /**
   * @generated from field: optional com.americanexpress.dining.tock.proto.TockPatron tock_patron = 3;
   */
  tockPatron?: TockPatron;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUser.
 * Use `create(AdminUserSchema)` to create a new message.
 */
export const AdminUserSchema: GenMessage<AdminUser> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 10);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminUserResponse
 */
export type AdminUserResponse = Message<"com.americanexpress.dining.bff.admin.proto.AdminUserResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminUser adminUsers = 1;
   */
  adminUsers: AdminUser[];

  /**
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminUserResponse.
 * Use `create(AdminUserResponseSchema)` to create a new message.
 */
export const AdminUserResponseSchema: GenMessage<AdminUserResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 11);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserProfileRequest
 */
export type GetUserProfileRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserProfileRequest"> & {
  /**
   * @generated from field: string gdus_uuid = 1;
   */
  gdusUuid: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserProfileRequest.
 * Use `create(GetUserProfileRequestSchema)` to create a new message.
 */
export const GetUserProfileRequestSchema: GenMessage<GetUserProfileRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 12);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserProfileResponse
 */
export type GetUserProfileResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserProfileResponse"> & {
  /**
   * @generated from field: optional com.americanexpress.dining.bff.admin.proto.AdminUser admin_user = 1;
   */
  adminUser?: AdminUser;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserProfileResponse.
 * Use `create(GetUserProfileResponseSchema)` to create a new message.
 */
export const GetUserProfileResponseSchema: GenMessage<GetUserProfileResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 13);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserHistoryRequest
 */
export type GetUserHistoryRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserHistoryRequest"> & {
  /**
   * @generated from field: string gdus_uuid = 1;
   */
  gdusUuid: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserHistoryRequest.
 * Use `create(GetUserHistoryRequestSchema)` to create a new message.
 */
export const GetUserHistoryRequestSchema: GenMessage<GetUserHistoryRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 14);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserHistoryResponse
 */
export type GetUserHistoryResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserHistoryResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminUserEvent events = 1;
   */
  events: AdminUserEvent[];
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserHistoryResponse.
 * Use `create(GetUserHistoryResponseSchema)` to create a new message.
 */
export const GetUserHistoryResponseSchema: GenMessage<GetUserHistoryResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 15);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserReservationsRequest
 */
export type GetUserReservationsRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserReservationsRequest"> & {
  /**
   * @generated from field: int64 tock_patron_id = 1;
   */
  tockPatronId: bigint;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional string selection = 3;
   */
  selection?: string;

  /**
   * @generated from field: optional uint64 resy_user_id = 4;
   */
  resyUserId?: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserReservationsRequest.
 * Use `create(GetUserReservationsRequestSchema)` to create a new message.
 */
export const GetUserReservationsRequestSchema: GenMessage<GetUserReservationsRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 16);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserReservationsResponse
 */
export type GetUserReservationsResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserReservationsResponse"> & {
  /**
   * @generated from field: com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup tock_reservations = 1;
   */
  tockReservations?: ReservationSourceGroup;

  /**
   * @generated from field: com.americanexpress.dining.bff.admin.proto.ReservationSourceGroup resy_reservations = 2;
   */
  resyReservations?: ReservationSourceGroup;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserReservationsResponse.
 * Use `create(GetUserReservationsResponseSchema)` to create a new message.
 */
export const GetUserReservationsResponseSchema: GenMessage<GetUserReservationsResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 17);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.AdminNotifySummary
 */
export type AdminNotifySummary = Message<"com.americanexpress.dining.bff.admin.proto.AdminNotifySummary"> & {
  /**
   * @generated from field: optional string venue_name = 1;
   */
  venueName?: string;

  /**
   * ISO dates (YYYY-MM-DD), sorted ascending — mirrors Notify.date in reservation.proto
   *
   * @generated from field: repeated string notify_dates = 2;
   */
  notifyDates: string[];

  /**
   * ISO local time (HH:MM[:SS], 24-hour, no timezone), e.g. "17:00" — mirrors Notify.start_time
   *
   * @generated from field: optional string preferred_start_time = 3;
   */
  preferredStartTime?: string;

  /**
   * ISO local time (HH:MM[:SS], 24-hour, no timezone) — mirrors Notify.end_time
   *
   * @generated from field: optional string preferred_end_time = 4;
   */
  preferredEndTime?: string;

  /**
   * @generated from field: optional int32 party_size = 5;
   */
  partySize?: number;

  /**
   * ISO-8601 datetime string in venue timezone
   *
   * @generated from field: optional string created_at = 6;
   */
  createdAt?: string;

  /**
   * ACTIVE | NOTIFIED | FULFILLED | CANCELED
   *
   * @generated from field: optional string status = 7;
   */
  status?: string;

  /**
   * TOCK (reserved for future RESY)
   *
   * @generated from field: optional string source = 8;
   */
  source?: string;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.AdminNotifySummary.
 * Use `create(AdminNotifySummarySchema)` to create a new message.
 */
export const AdminNotifySummarySchema: GenMessage<AdminNotifySummary> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 18);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryRequest
 */
export type GetUserNotifyHistoryRequest = Message<"com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryRequest"> & {
  /**
   * @generated from field: int64 tock_patron_id = 1;
   */
  tockPatronId: bigint;

  /**
   * defaults to 10
   *
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * reserved for future Resy support; ignored in v1
   *
   * @generated from field: optional uint64 resy_user_id = 3;
   */
  resyUserId?: bigint;
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryRequest.
 * Use `create(GetUserNotifyHistoryRequestSchema)` to create a new message.
 */
export const GetUserNotifyHistoryRequestSchema: GenMessage<GetUserNotifyHistoryRequest> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 19);

/**
 * @generated from message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryResponse
 */
export type GetUserNotifyHistoryResponse = Message<"com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryResponse"> & {
  /**
   * @generated from field: repeated com.americanexpress.dining.bff.admin.proto.AdminNotifySummary notifies = 1;
   */
  notifies: AdminNotifySummary[];
};

/**
 * Describes the message com.americanexpress.dining.bff.admin.proto.GetUserNotifyHistoryResponse.
 * Use `create(GetUserNotifyHistoryResponseSchema)` to create a new message.
 */
export const GetUserNotifyHistoryResponseSchema: GenMessage<GetUserNotifyHistoryResponse> = /*@__PURE__*/
  messageDesc(file_bff_admin_admin_user, 20);

/**
 * @generated from enum com.americanexpress.dining.bff.admin.proto.ReservationSourceStatus
 */
export enum ReservationSourceStatus {
  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_FAILED = 2;
   */
  FAILED = 2,

  /**
   * @generated from enum value: RESERVATION_SOURCE_STATUS_NOT_APPLICABLE = 3;
   */
  NOT_APPLICABLE = 3,
}

/**
 * Describes the enum com.americanexpress.dining.bff.admin.proto.ReservationSourceStatus.
 */
export const ReservationSourceStatusSchema: GenEnum<ReservationSourceStatus> = /*@__PURE__*/
  enumDesc(file_bff_admin_admin_user, 0);

/**
 * @generated from service com.americanexpress.dining.bff.admin.proto.AdminUserService
 */
export const AdminUserService: GenService<{
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.SearchUser
   */
  searchUser: {
    methodKind: "unary";
    input: typeof AdminUserRequestSchema;
    output: typeof AdminUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserProfile
   */
  getUserProfile: {
    methodKind: "unary";
    input: typeof GetUserProfileRequestSchema;
    output: typeof GetUserProfileResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserHistory
   */
  getUserHistory: {
    methodKind: "unary";
    input: typeof GetUserHistoryRequestSchema;
    output: typeof GetUserHistoryResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserReservations
   */
  getUserReservations: {
    methodKind: "unary";
    input: typeof GetUserReservationsRequestSchema;
    output: typeof GetUserReservationsResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetUserNotifyHistory
   */
  getUserNotifyHistory: {
    methodKind: "unary";
    input: typeof GetUserNotifyHistoryRequestSchema;
    output: typeof GetUserNotifyHistoryResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.SyncUser
   */
  syncUser: {
    methodKind: "unary";
    input: typeof SyncUserRequestSchema;
    output: typeof SyncUserResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.RetryGdaEligibility
   */
  retryGdaEligibility: {
    methodKind: "unary";
    input: typeof RetryGdaEligibilityRequestSchema;
    output: typeof RetryGdaEligibilityResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.DeactivateUsers
   */
  deactivateUsers: {
    methodKind: "unary";
    input: typeof DeactivateUsersRequestSchema;
    output: typeof DeactivateUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.ActivateUsers
   */
  activateUsers: {
    methodKind: "unary";
    input: typeof ActivateUsersRequestSchema;
    output: typeof ActivateUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.DeleteUsers
   */
  deleteUsers: {
    methodKind: "unary";
    input: typeof DeleteUsersRequestSchema;
    output: typeof DeleteUsersResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.AddSuspectedBot
   */
  addSuspectedBot: {
    methodKind: "unary";
    input: typeof AddSuspectedBotRequestSchema;
    output: typeof AddSuspectedBotResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.StartBulkUserAction
   */
  startBulkUserAction: {
    methodKind: "unary";
    input: typeof StartBulkUserActionRequestSchema;
    output: typeof StartBulkUserActionResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.GetBulkUserActionStatus
   */
  getBulkUserActionStatus: {
    methodKind: "unary";
    input: typeof GetBulkUserActionStatusRequestSchema;
    output: typeof BulkUserActionStatusSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.CancelBulkUserAction
   */
  cancelBulkUserAction: {
    methodKind: "unary";
    input: typeof CancelBulkUserActionRequestSchema;
    output: typeof CancelBulkUserActionResponseSchema;
  },
  /**
   * @generated from rpc com.americanexpress.dining.bff.admin.proto.AdminUserService.ResolveUsers
   */
  resolveUsers: {
    methodKind: "unary";
    input: typeof ResolveUsersRequestSchema;
    output: typeof ResolveUsersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bff_admin_admin_user, 0);

